import React, { Component } from "react";
import Navbar from "../components/Navbar";
import AppLayout from "../Layouts/AppLayout";

import { product, category } from "../service/FirebaseService/CloundFireStore/model";

export default class View1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: []
    };
  }

  async componentWillMount() {
    await product.subscribe(this.handleReciveData("products"));
  }

  handleReciveData = name => async data => {
    data = await product.includOptionalField(data, 'category',category)
    this.setState({ [name]: data });
  };

  handleGotoCreateProduct = () => {
    this.props.history.push('/products/create');
  }

  handleDel = (documentId) => async () => {
    product.softDeleteById(documentId);
  }

  handleEdit = (documentId) => () => {
    this.props.history.push(`/products/edit/${documentId}`);
  }

  renderTableBody = () => {
    return this.state.products.map((product, index) => {
      return (
        <tr key={index}>
          <td>{product.title}</td>
          <td>
            <img src={product.product_image_url} width="120px" height="120px" alt="" />
          </td>
          <td>{product.price}</td>
          <td>{product.unit}</td>
          <td>{product.category.title}</td>
          <td>
            <button
              onClick={this.handleEdit(product.documentId)}
              class="btn btn-info btn-sm"
            >
              Edit
            </button>
            <button class="btn btn-danger btn-sm ml-2" onClick={this.handleDel(product.documentId)}>
              Delete
            </button>
          </td>
        </tr>
      );
    });
  };

  render() {
    console.log(this.state);
    return (
      <div>
        <Navbar />
        <AppLayout>
          <div className="d-flex justify-content-end mb-2">
            <button onClick={this.handleGotoCreateProduct}  className="btn btn-success">Add Product</button>
          </div>

          <div className="card card-default">
            <div className="card-header">Products</div>
            <div className="card-body">
              <table className="table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>รูป</th>
                    <th>ราคา(บาท)</th>
                    <th>หน่วย</th>
                    <th>Category</th>
                  </tr>
                </thead>
                <tbody>{this.renderTableBody()}</tbody>
              </table>
            </div>
          </div>
        </AppLayout>
      </div>
    );
  }
}
